import axios from 'axios';

const URL = 'https://api.weatherapi.com/v1/forecast.json';
const URL1 = 'https://api.openweathermap.org/data/2.5/onecall';
const API_KEY = 'e1f953ebb9974c85982201749210902';
const API_KEY1 = 'f33a484cf794d08d0148764789aaba32';

export const fetchWeather = async (query) => {
    const data = await axios.get(URL, {
        params: {
            q: query,
            days: 3,
            key: API_KEY,
        }
    });

    return data;
}

// export const fetchWeather1 = async (latitude,longitude) => {
//     const { data } = await axios.get(URL1, {
//         params: {
//             lat: latitude,
//             lon: longitude,
//             units: 'metric',
//             APPID: API_KEY1,
//         }
//     });

//     return data1;
// }